"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Filter = _interopRequireDefault(require("./Filter"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "filter": "DefaultTheme__filter___viOff",
  "label": "DefaultTheme__label___2AAEW",
  "selected": "DefaultTheme__selected___3-Iqf",
  "filter-icon": "DefaultTheme__filter-icon___2bEE1",
  "filter-checkbox": "DefaultTheme__filter-checkbox___pduHc",
  "dropdown": "DefaultTheme__dropdown___3GYJ2",
  "dropdown-header": "DefaultTheme__dropdown-header___m2N06",
  "active": "DefaultTheme__active___1Nw-5",
  "filterIcon": "DefaultTheme__filter-icon___2bEE1",
  "filterCheckbox": "DefaultTheme__filter-checkbox___pduHc",
  "dropdownHeader": "DefaultTheme__dropdown-header___m2N06"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "filter": "DarkTheme__filter___37uyd",
  "label": "DarkTheme__label___n_kIH",
  "dropdown": "DarkTheme__dropdown___3F9AP",
  "dropdown-header": "DarkTheme__dropdown-header___3iyWH",
  "dropdownHeader": "DarkTheme__dropdown-header___3iyWH"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "filter": "LumeTheme__filter___K5sUa"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_Filter["default"].displayName, themes.DefaultTheme)(_Filter["default"]);
ThemedComponent.displayName = _Filter["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map